import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import mainKk from '@/locales/kk/main.json'
import mainEn from '@/locales/en/main.json'
import mainRu from '@/locales/ru/main.json'
import subscriptionKk from '@/locales/kk/subscription.json'
import subscriptionEn from '@/locales/en/subscription.json'
import subscriptionRu from '@/locales/ru/subscription.json'
import { getLangFromQuery } from '@/lib/utils';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: getLangFromQuery(),
    resources: {
      en: {
        main: mainEn,
        subscription: subscriptionEn
      },
      ru: {
        main: mainRu,
        subscription: subscriptionRu
      },
      kk: {
        main: mainKk,
        subscription: subscriptionKk
      }
    },
    fallbackLng: 'en',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;